import CdgFiltresController from './cdg.filtres.controller';
import Template from './cdg.filtres.html';

export default {
	bindings: {
		domaine: '<',
		isTransport: '<',
		listes: '=',
		frontFilters: '=',
		source: '<',
		onUpdate: '&',
		onDelete: '&'
	},
	template: Template,
	controller: CdgFiltresController
};
